module.exports = __webpack_public_path__ + "img/ic_drop_2.c67bd94f.svg";